import React from 'react'
import { Form, ModalBody, Button, Row, FormText, Col, ListGroup, ListGroupItem } from 'reactstrap';
import './StyleReturnReason.css';

export const FormIndicationsLab = (props) => {

    const {

        loading2, toggleLab, handleInputChange2, methodAction, button, indication2, validaciones2

    } = props;

    const {

        indication_valid

    } = validaciones2;

    return (
        <Form className="theme-form pt-3" role="form" onSubmit={methodAction}>
            <textarea
                rows={5}
                name="indication"
                value={indication2}
                onChange={handleInputChange2}
                className={`reason-textarea ${indication_valid ? "input-error" : ""}`}

                placeholder="Describe la indicación para el estudio del paciente..."
            />

            <Col md="12" className='text-center'>
                <FormText color="danger" hidden={!indication_valid} >Ingrese las indicaciones</FormText>
            </Col>

        </Form>

    )
}
